import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgreementService } from '../../providers/agreement.service';
import { AuthService } from '../../providers/auth.service';
import { Agreement_version } from '../../models/agreement_version';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
    standalone: false,
    selector: 'app-agreement-assent',
    templateUrl: './agreement-assent.component.html',
    styleUrls: ['./agreement-assent.component.css']
})
export class AgreementAssentComponent extends SmsAbstractAppPage implements OnInit {

    pending: Agreement_version[] = [];
    accepted: Set<string> = new Set();
    submitting = false;
    loading = true;

    constructor(
        private router: Router,
        private agreementService: AgreementService,
        private authService: AuthService,
    ) {
        super();
    }

    ngOnInit() {
        this.agreementService.checkAssentStatus().then(status => {
            if (status.all_current) {
                this.router.navigate(['home']);
                return;
            }
            this.pending = status.pending.map(v => new Agreement_version(v));
            this.loading = false;
        }).catch(error => {
            // Not authenticated — send to login
            this.router.navigate(['login']);
        });
    }

    get allAccepted(): boolean {
        return this.pending.length > 0 && this.pending.every(v => this.accepted.has(v.agreement_type));
    }

    hasPending(type: string): boolean {
        return this.pending.some(v => v.agreement_type === type);
    }

    toggleAccepted(type: string) {
        if (this.accepted.has(type)) {
            this.accepted.delete(type);
        } else {
            this.accepted.add(type);
        }
    }

    handleAccept() {
        if (!this.allAccepted || this.submitting) { return; }
        this.submitting = true;
        const types = this.pending.map(v => v.agreement_type);
        this.agreementService.recordAssent(types).then(() => {
            this.router.navigate(['home']);
        }).catch(error => {
            this.handleError(error);
            this.submitting = false;
        });
    }

    handleDeclineAndLogout() {
        this.authService.logout().then(() => {
            this.router.navigate(['login']);
        });
    }
}
